import React from 'react'
import { useTranslation } from 'react-i18next'

import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import { useUserStocks } from '../_load/UserStocksLoader'

const UserStocksTable = () => {
  const { t } = useTranslation('listStocks')
  const data = useUserStocks()

  const columns = [
    {
      label: t('userStocks.table.user'),
      dataIndex: 'user',
      flex: 1,
      bold: true,
      render: data => <Text>{data.name}</Text>
    },

    {
      label: t('userStocks.table.amount'),
      dataIndex: 'amount',
      flex: 1,
      render: data => <Text>{data}</Text>
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default UserStocksTable
